import React from 'react';

export const WOMENS_FIELD_LINE = 'rgb(var(--sd-line-strong))';

/**
 * Field width in the line drawing is 574.
 * The goal line is the arc's diameter, 255 wide, centered on that field.
 * The playground width is that field width, so the goal keeps this proportion
 * and the circle stays round.
 */
export const WOMENS_FIELD_W = 574;
const GOAL_H = 200;
const CX = 287.5;
const GY = 42;
const ARC = 147;
const CIRCLE = 30;
/** Space between the end line and the goal circle, matching the field drawing. */
const EDGE_GAP = 15;

/** One end of the women's field: goal line, circle, and the 8 meter arc. */
const WomensGoalSection: React.FC<{ edge: 'top' | 'bottom' }> = ({ edge }) => (
  <div className={`absolute left-0 right-0 w-full ${edge === 'top' ? 'top-0' : 'bottom-0'}`}>
    <div className="relative w-full" style={{ paddingTop: `${(EDGE_GAP / WOMENS_FIELD_W) * 100}%` }}>
      <svg
        viewBox={`0 0 ${WOMENS_FIELD_W} ${GOAL_H}`}
        preserveAspectRatio="xMidYMid meet"
        className={`absolute left-0 right-0 w-full ${edge === 'top' ? 'top-full' : 'bottom-full'}`}
        style={{
          aspectRatio: `${WOMENS_FIELD_W} / ${GOAL_H}`,
          transform: edge === 'bottom' ? 'scaleY(-1)' : undefined,
        }}
        aria-hidden
      >
        <g fill="none" stroke={WOMENS_FIELD_LINE} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
          <line x1={CX - ARC} y1={GY} x2={CX - CIRCLE} y2={GY} />
          <line x1={CX + CIRCLE} y1={GY} x2={CX + ARC} y2={GY} />
          <path d={`M ${CX - ARC} ${GY} A ${ARC} ${ARC} 0 0 0 ${CX + ARC} ${GY}`} />
          <circle cx={CX} cy={GY} r={CIRCLE} />
          <line x1={CX - 9} y1={GY} x2={CX + 9} y2={GY} />
          <line x1={CX + CIRCLE} y1={GY} x2="366.2" y2="85.6" />
          <line x1={CX - CIRCLE} y1={GY} x2="208.8" y2="85.6" />
          <path d="M 366.2 85.6 A 90 90 0 0 1 208.8 85.6" />
        </g>
      </svg>
    </div>
  </div>
);

export default WomensGoalSection;
